import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("lC5w8"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("jUFzu"), parcelRequire.load("6qO4J"), parcelRequire.load("W1Wpe"), parcelRequire.load("6Qjz5"), parcelRequire.load("au1C0")]).then(() => {
  return Promise.all([waitForCSS("/Accordion.faaa34b9.css")]);
}).then(() => {
let originalModule = parcelRequire("jFoC3");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("jUFzu")} />
  <link rel="modulepreload" href={parcelRequire.resolve("6qO4J")} />
  <link rel="stylesheet" href={parcelRequire.resolve("lC5w8")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("W1Wpe")} />
  <link rel="modulepreload" href={parcelRequire.resolve("6Qjz5")} />
  <link rel="modulepreload" href={parcelRequire.resolve("au1C0")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
